import { PageHeader } from '../../../app/shell.js';
import { SettingsForm } from './SettingsForm.js';

export function DataRetentionSettingsPage() {
  return (
    <>
      <PageHeader title="Data retention" />
      <main className="p-7">
        <SettingsForm
          namespace="data_retention"
          fields={[
            { key: 'archivedRecordPurgeDays', label: 'Purge archived records after (days)', type: 'number' },
            { key: 'auditLogRetentionDays', label: 'Retain audit logs for (days)', type: 'number' },
          ]}
        />
        <p className="mt-4 max-w-xl text-sm text-text-muted">
          This setting is stored but not yet enforced by a scheduled job — see
          docs/architecture/12-implementation-status.md.
        </p>
      </main>
    </>
  );
}
